<input
type="hidden"
class="form-control"
[id]="formControlName"
[formControl]="control"
>
<form-field-error [form-control]="control"></form-field-error>

